<script>
import { Line, mixins } from "vue-chartjs";

export default {
  extends: Line,
  mixins: [mixins.reactiveProp],
  props: {
    label: {
      type: String,
      default: "BTC"
    }
  },
  data: function() {
    return {
      options: {
        tooltips: {
          callbacks: {
            label: item => `${item.yLabel.toFixed(5)} ${this.label}`
          }
        },
        scales: {
          xAxes: [
            {
              type: "time"
            }
          ]
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/components/dashboard/Chart.vue